import { render, staticRenderFns } from "./ProfessionalDialog.vue?vue&type=template&id=3ce0f252&scoped=true&"
import script from "./ProfessionalDialog.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0f252",
  null
  
)

export default component.exports